export const initialState = () => ({
  tags: [],
});

const state = initialState();

export default state;
